// Cinematic CSS/SVG stand-in for BHU architecture photography.
// Swap this component for an <img> once real photos are provided.
export const BhuArt = ({ className = "" }) => (
    <svg
        viewBox="0 0 800 420"
        preserveAspectRatio="xMidYMax slice"
        className={className}
        aria-hidden="true"
    >
        <defs>
            <linearGradient id="bhu-sky" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2a0a0c" />
                <stop offset="55%" stopColor="#10090A" />
                <stop offset="100%" stopColor="#070708" />
            </linearGradient>
            <radialGradient id="bhu-glow" cx="50%" cy="32%" r="65%">
                <stop offset="0%" stopColor="#E3262E" stopOpacity="0.30" />
                <stop offset="45%" stopColor="#C91F26" stopOpacity="0.10" />
                <stop offset="100%" stopColor="#070708" stopOpacity="0" />
            </radialGradient>
        </defs>

        <rect width="800" height="420" fill="url(#bhu-sky)" />
        <circle cx="400" cy="150" r="260" fill="url(#bhu-glow)" />
        <circle cx="400" cy="150" r="86" fill="#E3262E" opacity="0.14" />

        {/* skyline silhouette */}
        <g fill="#070708">
            <rect x="0" y="352" width="800" height="68" />
            {/* connecting wall */}
            <rect x="96" y="330" width="608" height="30" />
            {/* central dome */}
            <path d="M312 352 A88 88 0 0 1 488 352 Z" />
            <rect x="352" y="236" width="96" height="34" />
            <rect x="396" y="196" width="8" height="42" />
            <circle cx="400" cy="192" r="7" />
            {/* flanking towers */}
            <rect x="216" y="248" width="46" height="104" />
            <path d="M210 252 A29 29 0 0 1 268 252 Z" />
            <rect x="536" y="248" width="46" height="104" />
            <path d="M530 252 A29 29 0 0 1 588 252 Z" />
            {/* outer minarets */}
            <rect x="118" y="284" width="24" height="68" />
            <path d="M114 288 A16 16 0 0 1 146 288 Z" />
            <rect x="658" y="284" width="24" height="68" />
            <path d="M654 288 A16 16 0 0 1 686 288 Z" />
        </g>
        {/* windows catching light */}
        <g fill="#C91F26" opacity="0.55">
            <rect x="236" y="286" width="7" height="18" />
            <rect x="557" y="286" width="7" height="18" />
            <rect x="128" y="308" width="5" height="12" />
            <rect x="667" y="308" width="5" height="12" />
            <rect x="392" y="330" width="16" height="22" />
        </g>
        {/* horizon line */}
        <rect x="0" y="351" width="800" height="1" fill="#C91F26" opacity="0.5" />
    </svg>
);
